import Backbone from 'backbone';
import * as d3 from 'd3';

export default class SummaryScrollbar extends Backbone.View {
  static initClass() {
    this.prototype.tagName = 'rect';
    this.prototype.className = 'summary-scrollbar';
  }

  initialize(options) {
    this.range = options.range;
    this.slice = options.slice;
    this.tabstate = options.tabstate;
    this.fullHeight = options.fullHeight;
  }

  registerListeners() {
    this.listenTo(this.model, 'change:position', this.updateThumb);
    this.listenTo(this.model, 'change:endPosition', this.updateThumb);
    this.listenTo(this.model, 'change:size', this.updateThumb);
    this.listenTo(this.range, 'change', this.updateThumb);
  }

  updateThumb(model, value, options) {
    const pos = this.model.get('position');
    const size = this.model.get('size');
    const visible = this.model.get('endPosition') - this.model.get('position') + 1;

    d3.select(this.el).classed('hidden', visible >= size);

    const fullHeight = this.fullHeight();
    const thumbHeight = (fullHeight / size) * visible;
    const extraHeight = Math.max(5 - thumbHeight, 0);
    const showHeight = fullHeight - extraHeight;
    const maxTop = fullHeight - thumbHeight;
    const y = Math.min(maxTop, (pos / size) * showHeight);

    const xFn = this.slice.x();
    const x = xFn(this.range.start());
    const width = xFn(this.range.span());

    d3.select(this.el)
      .datum({x: 0, y})
      .attr('x', x - 5)
      .attr('width', width + 10)
      .attr('y', y)
      .attr('height', thumbHeight);
  }

  handleDrag(e, d) {
    this.setPosition(d, e.y);
  }

  setPosition(d, y) {
    const height = this.fullHeight();
    const size = this.model.get('size');
    y = Math.min(height, Math.max(0, y));
    d.y = y;
    const pos = Math.min(size - 1, Math.max(0, (y / height) * size));
    this.model.setPosition(pos, {who: this.cid});
  }

  handleDragEnd(d) {
    this.$el.removeClass('drag');
  }

  handleDragStart(d) {
    this.$el.addClass('drag');
  }

  posFromY(y) {
    const height = this.fullHeight();
    const size = this.model.get('size');
    y = Math.min(height, Math.max(0, y));
    return Math.min(size - 1, Math.max(0, (y / height) * size));
  }

  render() {
    this.registerListeners();

    const origin = (e, d) => {
      const y = d3.pointer(e, this.el)[1];
      const middle = this.posFromY(y);
      if (this.model.get('position') > middle || middle > this.model.get('endPosition') + 1) {
        this.setPosition(d, y);
      }
      return d;
    };

    const drag = d3
      .drag()
      .subject(origin)
      .on('drag', (e, d) => {
        this.handleDrag(e, d);
      })
      .on('start', (e, d) => {
        this.handleDragStart(d);
      })
      .on('end', (e, d) => {
        this.handleDragEnd(d);
      });

    d3.select(this.el).datum({x: 0, y: 0}).call(drag);
    this.updateThumb();
    return this;
  }
}
SummaryScrollbar.initClass();
